import axios from 'axios';
import React, { useState, useEffect } from 'react';
import Pagination from '../../components/Pagination.tsx';
import { useTheme } from "../../contexts/ThemeContext.tsx";
import { getTheme } from '../../theme.ts';

const AdminPayments = () => {
    const { themeName } = useTheme();
    const currentTheme = getTheme(themeName);
    const rawData = localStorage.getItem('user');
    const cred = rawData ? JSON.parse(rawData) : null;
    const token = cred?.access;
    const [allPayments, setAllPaymets] = useState<any[]>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(18);

    const getAllPayments = async () => {
        try {
            const response: any = await axios.get(`${process.env.REACT_APP_DB_URI}/users/payment/`, {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            })
            setAllPaymets(response?.data)
        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        getAllPayments()
    }, [])

    // Pagination calculations
    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const paginatedPayments = allPayments.slice(startIndex, endIndex);
    const totalPages = Math.ceil(allPayments.length / rowsPerPage);

    return (
        <div style={{ backgroundColor: currentTheme.background }}>
            <div className="shadow-lg rounded-xl overflow-hidden" style={{ backgroundColor: currentTheme.surface }}>
                <table className="min-w-full text-sm" style={{ backgroundColor: currentTheme.surface, color: currentTheme.text }}>
                    <thead className="sticky top-0 z-10" style={{ backgroundColor: currentTheme.primary }}>
                        <tr>
                            <th className="py-2 px-3 text-left" style={{ color: currentTheme.inverseText }}>Order ID</th>
                            <th className="py-2 px-3 text-left" style={{ color: currentTheme.inverseText }}>User</th>
                            <th className="py-2 px-3 text-left" style={{ color: currentTheme.inverseText }}>Type</th>
                            <th className="py-2 px-3 text-left" style={{ color: currentTheme.inverseText }}>Plan</th>
                            <th className="py-2 px-3 text-left" style={{ color: currentTheme.inverseText }}>Amount</th>
                            <th className="py-2 px-3 text-left" style={{ color: currentTheme.inverseText }}>Status</th>
                            <th className="py-2 px-3 text-left" style={{ color: currentTheme.inverseText }}>Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {paginatedPayments.length === 0 ? (
                            <tr>
                                <td colSpan={7} className="text-center py-6" style={{ color: currentTheme.textSecondary }}>No payments found.</td>
                            </tr>
                        ) : (
                            paginatedPayments.map(payment => (
                                <tr key={payment.id} className="transition" style={{ borderBottom: `1px solid ${currentTheme.border}` }}>
                                    <td className="py-2 px-3 break-all max-w-[120px]">{payment.order?.slice(0, 8)}...</td>
                                    <td className="py-2 px-3">{payment.user}</td>
                                    <td className="py-2 px-3">{payment.payment_type}</td>
                                    <td className="py-2 px-3">
                                        {payment.order_details?.subscription?.title || "-"}
                                    </td>
                                    <td className="py-2 px-3 font-semibold" style={{ color: currentTheme.text }}>
                                        ₹{payment.order_details?.amount}
                                    </td>
                                    <td className="py-2 px-3">
                                        <span className="px-2 py-1 rounded text-xs font-semibold" style={{
                                            backgroundColor: payment.status === "PENDING" ? currentTheme.warning + '33' : payment.status === "COMPLETED" ? currentTheme.success + '33' : currentTheme.error + '33',
                                            color: payment.status === "PENDING" ? currentTheme.warning : payment.status === "COMPLETED" ? currentTheme.success : currentTheme.error
                                        }}>
                                            {payment.status}
                                        </span>
                                    </td>
                                    <td className="py-2 px-3" style={{ color: currentTheme.textSecondary }}>
                                        {new Date(payment.payment_date).toLocaleString()}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* Pagination Controls */}
            {allPayments.length > 0 && (
                <div className="flex items-center justify-between px-4 py-3 border-t" style={{ borderColor: currentTheme.border }}>
                    <div className="flex items-center gap-3">
                        <span className="text-sm" style={{ color: currentTheme.textSecondary }}>Rows per page:</span>
                        <select
                            value={rowsPerPage}
                            onChange={(e) => {
                                setRowsPerPage(Number(e.target.value));
                                setCurrentPage(1);
                            }}
                            className="px-3 py-1 rounded border text-sm focus:outline-none focus:ring-2"
                            style={{
                                backgroundColor: currentTheme.surface,
                                color: currentTheme.text,
                                borderColor: currentTheme.border
                            }}
                        >
                            <option value={18}>18</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </select>
                        <span className="text-sm" style={{ color: currentTheme.textMuted }}>
                            Showing {allPayments.length === 0 ? 0 : startIndex + 1}-{Math.min(endIndex, allPayments.length)} of {allPayments.length} payments
                        </span>
                    </div>
                    <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} />
                </div>
            )}
        </div>
    )
}

export default AdminPayments;